import { DateTime } from 'luxon';
import { z } from 'zod';
import { errorCommonI18n } from '@_/i18n-common';

export const dateYmdSchema = () =>
  z.string().refine(
    data => {
      try {
        return DateTime.fromFormat(data, 'yyyy/L/d').isValid;
      } catch (err) {
        return false;
      }
    },
    {
      params: {
        i18nMessage: errorCommonI18n.invalidDate
      }
    }
  );
